module.exports = __webpack_public_path__ + "media/images/tour/m/en-4be8993cffff60e0d9bd140e3c1cad2b.png";